import React from "react";
import { Helmet } from "react-helmet";
import InvestorGrievanceTable from "./InvestorGrievanceTable";
import "../Style.scss";

const InvestorGrievance = () => {

  return (
    <>
      <Helmet>
        <title>Investor Grievance ~ Algoquant Global</title>
      </Helmet>
      <div className="wrapper investroGrievanceContainer">
        <div className="investroGrievanceHeader container headerforall">
          <div className="leftHeader">
            <h1>INVESTOR GRIEVANCE</h1>
          </div>
          <div className="rightHeader">
            <nav aria-label="breadcrumb">
              <ol class="breadcrumb">
                <li class="breadcrumb-item">
                  <a href="/" className="inActive">
                    Home
                  </a>
                </li>
                <li class="breadcrumb-item active" aria-current="page">
                  Investor Grievance
                </li>
              </ol>
            </nav>
          </div>
        </div>
        <hr width="100%" />
        <InvestorGrievanceTable />
      </div>
    </>
  );
};

export default InvestorGrievance;
